import { render, staticRenderFns } from "./RmaHandlingCust.vue?vue&type=template&id=c56e4912&"
import script from "./RmaHandlingCust.vue?vue&type=script&lang=js&"
export * from "./RmaHandlingCust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports